import React, { useEffect, useState } from "react";
import CardDiv from "../../common/card-div/CardDiv";
import { Button } from "react-bootstrap";
import { Table, Form } from "antd";
import { Offcanvas } from "react-bootstrap";
import moment from "moment";
import {
  buildQueryString,
  filterAndTransformParams,
} from "../../../modules/utilities/utility";
import Filter from "../filter/Filter";

const IncentivesDashboard = ({
  title,
  fetchIncentives,
  fetchIncentivesFilter,
  incentivesData,
  incentivesFilterData,
  incentivesFilterDataLoading,
}) => {
  const [visible, setVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [triggerFetch, setTriggerFetch] = useState(true);
  const [savedFormValues, setSavedFormValues] = useState({});
  const [form] = Form.useForm();

  const getTodayDate = moment().format("YYYY-MM-DD");

  const [queryParam, setQueryParam] = useState({
    pageSize,
    pageNumber: currentPage,
    agentUserId: "",
    agentRmUserId: "",
    empType: "",
    incentiveMonthDate: getTodayDate,
  });

  const [filterQueryParams, setFilterQueryParams] = useState({
    empType: "",
  });

  useEffect(() => {
    if (triggerFetch) {
      const updatedFilters = filterAndTransformParams(queryParam);
      const queryString = buildQueryString(updatedFilters);
      fetchIncentives(queryString);
      setTriggerFetch(false);
    }
  }, [triggerFetch, queryParam]);

  useEffect(() => {
    const updatedFilters = filterAndTransformParams(filterQueryParams);
    const queryString = buildQueryString(updatedFilters);
    fetchIncentivesFilter(queryString);
  }, [filterQueryParams]);

  const handleApplyFilters = (filters) => {
    const mergedFilters = {
      ...queryParam,
      ...filters,
      pageSize: 10,
      pageNumber: 1,
    };

    const finalFilters = filterAndTransformParams(mergedFilters);
    setQueryParam(finalFilters);
    setTriggerFetch(true);
    setCurrentPage(1);
    setPageSize(10);
    setVisible(false);
  };

  const handleTableChange = (pagination) => {
    const updatedPagination = {
      ...queryParam,
      pageSize: pagination.pageSize,
      pageNumber: pagination.current,
    };
    setPageSize(pagination.pageSize);
    setCurrentPage(pagination.current);
    setQueryParam(updatedPagination);
    setTriggerFetch(true);
  };

  const handleFinish = (values) => {
    handleApplyFilters(values);
    setSavedFormValues(values);
    setVisible(false);
  };

  const getStartOfMonth = moment().startOf("month").format("YYYY-MM-DD");

  const handleClear = () => {
    form.resetFields();

    const initialQueryParam = {
      pageSize: 10,
      pageNumber: 1,
      agentUserId: "",
      agentRmUserId: "",
      empType: "",
      incentiveMonthDate: getStartOfMonth,
    };

    const updatedFilters = filterAndTransformParams(initialQueryParam);
    const queryString = buildQueryString(updatedFilters);
    fetchIncentives(queryString);
    setCurrentPage(1);
    setPageSize(10);
    setSavedFormValues({});
    setVisible(false);
  };

  return (
    <CardDiv
      title={title}
      component={
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: 10,
            }}
          >
            <Button
              variant="primary"
              onClick={() => setVisible(true)}
              style={{ marginRight: 10 }}
            >
              Filter
            </Button>
            <Offcanvas
              show={visible}
              onHide={() => setVisible(false)}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Filter for {title}</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Filter
                  setFilterQueryParams={setFilterQueryParams}
                  savedFormValues={savedFormValues}
                  handleClear={handleClear}
                  handleFinish={handleFinish}
                  filterData={incentivesFilterData}
                  filterDataLoading={incentivesFilterDataLoading}
                />
              </Offcanvas.Body>
            </Offcanvas>
            <span className="shadow p-2 text-nowrap text-center">
              Results: {incentivesData.total_row_count}
            </span>{" "}
          </div>

          <div className="table-responsive">
            <Table
              columns={incentivesData.headers}
              dataSource={incentivesData.rows_data}
              onChange={handleTableChange}
              bordered
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: incentivesData.total_row_count,
                showSizeChanger: true,
              }}
              scroll={{ x: "max-content" }}
            />
          </div>
        </>
      }
    />
  );
};

export default IncentivesDashboard;
